// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2sI2Z","noInteraction":"EventWrapper_noInteraction__1PdJK","pointerPassthrough":"EventWrapper_pointerPassthrough__19mMU"};